import { render } from "./SelectedFilters.vue?vue&type=template&id=f5f5c574&scoped=true"
import script from "./SelectedFilters.vue?vue&type=script&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&lang=js"

import "./SelectedFilters.vue?vue&type=style&index=0&id=f5f5c574&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f5c574"]])

export default __exports__